import React from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useFlags } from "launchdarkly-react-client-sdk";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { buttonNotShowOnGORoom, checkScreenShareFeatureAvailable, handleClickOnStartScreenShare } from "../../../Twilio/ScreenShare/ScreenShareUtils";
import { SCREEN_SHARE_AVAILABILITY_TYPES } from "../../../../constants/BottomMenuConstants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";

const ScreenShareVideoButton = () => {
    const localisedValues = useLanguageChange();
    const ldFlags = useFlags();

    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const { screenShareUnsupportedMsg } = useSelector((state) => state.twilioEvents);

    const isScreenShareBtnVisible = () => {
        if (GLOBAL_MEETING_DATA.isAgent && ldFlags.hideStartVideoButton === true) {
            return false;
        }

        if (PublicVariables.featureFlag?.SHOWMESCREENSHARE == SCREEN_SHARE_AVAILABILITY_TYPES.availableForAllParticipant) {
            // Hide Screen share button for agent when agent join call MWEB
            if (GLOBAL_MEETING_DATA.isAgent && PublicVariables.isMobile) {
                return false;
            }
        }

        return checkScreenShareFeatureAvailable() && !buttonNotShowOnGORoom() && (isEmpty(screenShareUnsupportedMsg) || PublicVariables.isIOSDevice);
    };

    return (
        <>
            {isScreenShareBtnVisible() && (
                <div className='button-out'>
                    <div className='button'>
                        <button
                            className='btn short-btn'
                            disabled={!isRemoteParticipantJoined}
                            onClick={handleClickOnStartScreenShare}
                            data-testid='home-screenShare-button'
                        >
                            <span className='for-icon icon-share-screen'></span>
                            <span className='for-text'>{localisedValues["start_screen_share"]}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ScreenShareVideoButton;
